import React from 'react';

export interface INavMenuItem {
  id: string;
  label: string;
  isVisible?: boolean;
}

interface IDesktopNavMenuProps {
  items: INavMenuItem[];
  activeSection: string;
  onScrollToSection: (sectionId: string) => void;
}

/**
 * DesktopNavMenu Component
 * Renders the sticky left-hand navigation menu for the hotel detail page (desktop only).
 * Each item highlights when active and scrolls to its corresponding section on click.
 */
export const DesktopNavMenu: React.FC<IDesktopNavMenuProps> = ({ items, activeSection, onScrollToSection }) => {
  // Filter to only visible items
  const visibleItems = items.filter(item => item.isVisible !== false);

  return (
    <div id="left-nav-wrapper" className="hidden lg:block lg:sticky lg:w-[180px] top-[160px] self-start">
      <div className="h-[30px] -mt-[30px] bg-white"></div>
      <div id="left-nav" className="bg-gray-10">
        <div className="flex flex-col gap-[10px] py-[20px]">
          {visibleItems.map(item => (
            <NavMenuItem
              key={item.id}
              id={item.id}
              label={item.label}
              isActive={activeSection === item.id}
              onClick={() => onScrollToSection(item.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

interface INavMenuItemProps {
  id: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

/**
 * Individual navigation menu item
 */
const NavMenuItem: React.FC<INavMenuItemProps> = ({ label, isActive, onClick }) => {
  return (
    <span
      onClick={onClick}
      className={`font-pt-sans text-[15px] leading-[34px] px-[20px] cursor-pointer transition-all ${
        isActive
          ? 'font-bold text-green-hard bg-teal-20'
          : 'font-normal text-black hover:bg-teal-20 hover:text-green-hard hover:font-bold'
      }`}
    >
      {label}
    </span>
  );
};
